import { ReactComponent as BullHorn } from "assets/images/v2/bullhorn.svg";
import { ReactComponent as ChevronRight } from "assets/images/v2/chevron-right.svg";
import { useSelector } from "react-redux";
import { selectPreferredLanguage } from "features/authSlice";
import { PROFILE_COMMUNICATION_PREFERENCES_LABEL, PROFILE_COMMUNICATION_PREFERENCES_SUBTITLE } from "utilities/Constant";
import {
  getPersistedPreferredLanguage,
  getPreferredLanguage,
  isSpanishLanguage,
} from "utilities/getPreferredLanguage";
import EnglishOnlyBadge from "components/ui/english-only-badge/EnglishOnlyBadge";
import styles from "./profile-communication.module.scss";

export interface ProfileCommunicationPreferencesProps {
 readonly onClickPreference?: () => void;
}

export default function ProfileCommunicationPreferences({ onClickPreference }: ProfileCommunicationPreferencesProps) {
  const reduxLanguage = useSelector(selectPreferredLanguage);
  const resolvedLanguage = getPersistedPreferredLanguage() ?? reduxLanguage;
  const isSpanishUi = isSpanishLanguage(getPreferredLanguage(resolvedLanguage));

  return (
    <div className={styles.profileCommunicationWrapper}>
      <button
        type="button"
        onClick={onClickPreference}
        className={styles.profileCommunicationCard}
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClickPreference?.(); }}
      >
        <div className={styles.profileCommunicationTitle}>
          <BullHorn className="icon" />
          <span>{PROFILE_COMMUNICATION_PREFERENCES_LABEL}</span>
          {isSpanishUi && <EnglishOnlyBadge />}
        </div>
        <div className={styles.profileCommunicationInfo}>
          <p className="nav-subtitle">{PROFILE_COMMUNICATION_PREFERENCES_SUBTITLE}</p>
          <ChevronRight  className={styles.profileCommunicationRightIcon} aria-label="chevron right" />
        </div>
      </button>
    </div>
  );
}
